<main class="shippn-b2b-pages-main-wrapper">
  <aside class="shippn-b2b-pages-nav-wrapper">
    <div class="shippn-b2b-pages-nav-profile">
      <h5 translate="no">
        {{memberDetails?.company_name}}
        <span class="show-on-hover"
          (click)="copyToClipboard(memberDetails?.email, 'Email')">{{memberDetails?.email}}</span>
      </h5>
    </div>
    <div class="shippn-b2b-pages-nav-menu">
      <button class="active" (click)="reloadComponent()"> <i class="fas fa-box-open"></i> Create
        Shipment</button>
      <button [routerLink]="['/', 'b2b', 'dashboard']"> <i class="fas fa-boxes"></i>
        Shipments</button>
      <button [routerLink]="['/', 'b2b', 'pickups']"> <i class="fas fa-shipping-fast"></i> Pickups</button>
    </div>

    <div class="shippn-b2b-page-nav-footer for-desktop">
      <button class="btn btn-light" [routerLink]="['/', 'settings', 'api-keys']"><i class="fas fa-user-cog"></i>
        Account Settings</button>
        <div style="display: flex; justify-content: center; margin-top: 15px;">
          <a [routerLink]="['/', 'b2b', 'shipment-create']" style="font-size: 13px; text-align: center;">Switch to old version</a>
        </div>
    </div>
  </aside>
  <section class="shippn-b2b-pages-content-wrapper">
    <div class="shippn-b2b-pages-content-content-wrapper">
      <div class="dashboard-card-content-border-radius"
        style="background: #fff;padding:0;"
        [ngClass]="currentStep >= 3  ? 'full-height-dashboard' : 'dashboard-height-630'">
        <div id="shippn-scroll" style="height:100%;max-height: 100%;overflow: auto; padding: 15px;"
          class="table-responsive">
          <mat-stepper linear #stepper class="shippn-b2b-create-shipment-stepper" [@.disabled]="true"
            [ngClass]="{'shippn-become-an-affiliate-stepper-step-1-done': currentStep, 'hide-stepper-header': currentStep == 4}"
            [selectedIndex]="currentStep">
            <mat-step [stepControl]="form">
              <ng-template matStepLabel>Address</ng-template>
              <div class="shippn-b2b-create-shipment-stepper-step-container">
                <div class="row">
                  <div class="col-md-3">
                    <div class="sender-information-card" style="margin-bottom: 20px;">
                      <h5 class="shippn-b2b-create-shipment-stepper-content-card-title">Sender Information</h5>
                      <h6>Return Contact:</h6>
                      <div class="sender-information-box" *ngIf="customSenderInfo.addressLineOne">
                        <h5 class="sender-information-sender-name">{{customSenderInfo?.senderName}}</h5>
                        <p class="sender-information-sender-email">{{customSenderInfo?.senderEmail}}</p>
                        <h6 class="sender-from-address-title">From Address:</h6>
                        <p class="sender-information-sender-address">
                          {{customSenderInfo?.addressLineOne}}
                          {{customSenderInfo?.addressLineTwo}}
                          {{customSenderInfo?.cityName}}/{{customSenderInfo?.state}}
                          {{customSenderInfo?.postCode}}
                        </p>
                      </div>
                      <button class="btn b2b-create-shipment-select-sender-btn" (click)="openSelectSenderDialog()"
                        *ngIf="(userID === '66b5f93192539c6048a62356' && memberDetails?.addresses.length > 0) || (userID === '676b353892539c44f3fc22bd' && memberDetails?.addresses.length > 0) || (userID === '678e4eca92539c1a0d4cacca' && memberDetails?.addresses.length > 0)">
                        <i class="fas fa-hand-pointer"></i> Select Sender
                        Info</button>
                      <button class="btn b2b-create-shipment-add-btn" (click)="openChangeSenderDialog()"
                        *ngIf="!customSenderInfo.addressLineOne || userID === '66b5f93192539c6048a62356' || userID === '676b353892539c44f3fc22bd' || userID === '678e4eca92539c1a0d4cacca'">
                        <i class="fas fa-plus"></i> Add Sender
                        Info</button>


                    </div>
                  </div>
                  <div class="col-md-9" style="padding:0;">
                    <form ngNativeValidate [formGroup]="form">
                      <h5 class="shippn-b2b-create-shipment-stepper-content-card-title" style=" margin-left: 15px;">
                        Recipient</h5>
                      <div class="row">
                        <div class="col-12 col-lg-6">
                          <label class="shippn-form-label">
                            Send To / Recipient*
                          </label>
                          <input type="text" name="name" id="recipientName" formControlName="recipient"
                            autocomplte="name"
                            [ngClass]="{'shippn-border-red':form.get('recipient').touched && form.get('recipient').invalid}"
                            placeholder="" class="form-control form-control-sm shippn-input">
                        </div>
                        <div class="col-12 col-lg-6">
                          <label class="shippn-form-label">
                            Company Name
                          </label>
                          <input type="text" autocomplete="organization" name="companyName" id="companyName"
                            maxlength="35" formControlName="companyName"
                            [ngClass]="{'shippn-border-red':form.get('companyName').touched && form.get('companyName').invalid}"
                            placeholder="" class="form-control form-control-sm shippn-input">
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-lg-6">
                          <label class="shippn-form-label">
                            Email Address*
                          </label>
                          <input type="email" autocomplete="email" formControlName="emailAddress" name="email"
                            id="recipientEmail"
                            [ngClass]="{'shippn-border-red':form.get('emailAddress').touched && form.get('emailAddress').invalid}"
                            placeholder="" class="form-control form-control-sm shippn-input">
                        </div>
                        <div class="col-12 col-lg-6">
                          <label class="shippn-form-label">
                            Phone Number*
                          </label>
                          <input type="text" maxlength="35" autocomplete="tel" formControlName="phoneNumber"
                            name="phone" id="phoneNumber"
                            [ngClass]="{'shippn-border-red':form.get('phoneNumber').touched && form.get('phoneNumber').invalid}"
                            placeholder="" class="form-control form-control-sm shippn-input">
                        </div>
                      </div>
                      <h5 class="shippn-b2b-create-shipment-stepper-content-card-title"
                        style="margin-top: 30px; margin-left: 15px;">Addresses</h5>
                      <div>
                        <div class="row">
                          <div class="col-12 col-lg-6">
                            <label class="shippn-form-label">
                              Line 1*
                            </label>
                            <input #placesRef type="text"
                              formControlName="addressLineOne" name="address" id="addressLine1"
                              autocomplete="address-line1"
                              [ngClass]="{'shippn-border-red':form.get('addressLineOne').touched && form.get('addressLineOne').invalid}"
                              placeholder="Address Line 1" class="form-control form-control-sm shippn-input">
                          </div>
                          <div class="col-12 col-lg-6">
                            <label class="shippn-form-label">
                              Line 2
                            </label>
                            <input type="text" maxlength="35" formControlName="addressLineTwo"
                              autocomplete="address-line2"
                              [ngClass]="{'shippn-border-red':form.get('addressLineTwo').touched && form.get('addressLineTwo').invalid}"
                              placeholder="Address Line 2" class="form-control form-control-sm shippn-input">
                          </div>
                        </div>
                        <div class="row">
                          <div style="margin-top: 10px;" class="col-12 col-lg-3">
                            <label class="shippn-form-label">
                              Country*
                            </label>
                            <div class="select--wrapper" style="background-color: white; border-radius:5px">
                              <i class="fas fa-chevron-down"
                                style="position: absolute; right: 8px; top: 16px;float: right; color: #222222;font-size: 12px;"
                                aria-hidden="true"></i>
                              <select (change)="changeAddCountry()"
                                [ngClass]="{'shippn-border-red':form.get('country').touched && form.get('country').invalid}"
                                formControlName="country" style="width: 100%; border-radius: 5px;height:42px;"
                                class="form-control-sm" autocomplete="tel-country-code">
                                <option value="">Country</option>
                                <option value="{{country.code}}" *ngFor="let country of allCountries">
                                  <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                                  <span *ngIf="country.code == 'TR' || country.name == 'Turkey'"
                                    translate="no">Türkiye</span>
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-12 col-lg-3" style="margin-top: 10px;">
                            <label class="shippn-form-label">
                              Post Code*
                            </label>
                            <input type="text" formControlName="postCode"
                              [ngClass]="{'shippn-border-red':form.get('postCode').touched && form.get('postCode').invalid}"
                              placeholder="Post Code" class="form-control form-control-sm shippn-input"
                              autocomplete="postal-code">
                          </div>
                          <div class="col-12 col-lg-3" style="margin-top: 10px;">
                            <label class="shippn-form-label">
                              State*
                            </label>
                            <input type="text" formControlName="state" autocomplete="address-level1"
                              [ngClass]="{'shippn-border-red':form.get('state').touched && form.get('state').invalid}"
                              placeholder="State" class="form-control form-control-sm shippn-input">
                          </div>
                          <div style="margin-top: 10px;" class="col-12 col-lg-3">
                            <label class="shippn-form-label">
                              City Name*
                            </label>
                            <input type="text" formControlName="cityName" autocomplete="address-level2"
                              [ngClass]="{'shippn-border-red':form.get('cityName').touched && form.get('cityName').invalid}"
                              placeholder="City Name" class="form-control form-control-sm shippn-input">
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <!-- <div class="shippn-b2b-create-shipment-stepper-controls-wrapper">
                        <button mat-flat-button color="primary" class="shippn-mat-btn" matStepperNext>Next:
                          Customs</button>
                      </div> -->
            </mat-step>
            <!-- Customs -->
            <mat-step [stepControl]="customsForm">
              <ng-template matStepLabel>Customs</ng-template>
              <div class="shippn-b2b-create-shipment-stepper-step-container">
                <div class="row">
                  <div class="col-12 col-md-7">
                    <form ngNativeValidate [formGroup]="customsForm">
                      <div class="form-section-title">
                        <h5 style="padding-left: 15px;">Customs Info:</h5>
                      </div>
                      <div class="row">
                        <div class="col-12 col-lg-6">
                          <label class="shippn-form-label">
                            Content Type
                          </label>
                          <div style=" position: relative;">

                            <i class="fas fa-chevron-down"
                              style="position: absolute; right: 12px; top: 9px;float: right; color: #a8a8a8; border-radius: 32%; padding: 7px; font-size: 12px;"
                              aria-hidden="true"></i>
                            <select formControlName="contentType"
                              style="-webkit-appearance: none;-moz-appearance: none;appearance: none; margin-bottom: 5px; width: 100%; border-radius: 5px;background-color: transparent;height: 40px; position: relative; z-index: 2;cursor: pointer;"
                              class="form-control-sm">
                              <option value="Merchandise">Merchandise</option>
                              <option value="gift">Gift</option>
                              <option value="documents">Documents</option>
                            </select>

                          </div>
                        </div>
                        <div class="col-12 col-lg-6">
                          <label class="shippn-form-label">
                            Explanation of Content
                          </label>
                          <input type="text" formControlName="explanationOfContent"
                            [ngClass]="{'shippn-border-red':customsForm.get('explanationOfContent').touched && customsForm.get('explanationOfContent').invalid}"
                            placeholder="Describe Contents" class="form-control form-control-sm shippn-input">
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-lg-6">
                          <label class="shippn-form-label">
                            Restriction Type
                          </label>
                          <div style=" position: relative;">

                            <i class="fas fa-chevron-down"
                              style="position: absolute; right: 12px; top: 9px;float: right; color: #a8a8a8; border-radius: 32%; padding: 7px; font-size: 12px;"
                              aria-hidden="true" *ngIf="!isSelectsDisabled"></i>
                            <select formControlName="restrictionType"
                              style="-webkit-appearance: none;-moz-appearance: none;appearance: none;margin-bottom: 5px; width: 100%; border-radius: 5px;background-color: transparent;height: 40px; position: relative; z-index: 2;cursor: pointer;"
                              class="form-control-sm">
                              <option value="None">None</option>
                            </select>

                          </div>
                        </div>
                        <div class="col-12 col-lg-6">
                          <label class="shippn-form-label">
                            Explanation of Restriction Type
                          </label>
                          <input type="text" formControlName="explanationOfRestrictionType"
                            [ngClass]="{'shippn-border-red':customsForm.get('explanationOfRestrictionType').touched && customsForm.get('explanationOfRestrictionType').invalid}"
                            placeholder="Comments on Restriction Type"
                            class="form-control form-control-sm shippn-input">
                        </div>
                      </div>
                      <div class="row">
                        <!-- <div class="col-12 col-lg-6">
                                  <label class="shippn-form-label">
                                    Non-Delivery Action
                                  </label>
                                  <div style=" position: relative;">

                                    <i class="fas fa-chevron-down"
                                      style="position: absolute; right: 12px; top: 9px;float: right; color: #a8a8a8; border-radius: 32%; padding: 7px; font-size: 12px;"
                                      aria-hidden="true" *ngIf="!isSelectsDisabled"></i>
                                    <select formControlName="nonDeliveryAction"
                                      style="-webkit-appearance: none;-moz-appearance: none;appearance: none; margin-bottom: 5px; width: 100%; border-radius: 5px;background-color: transparent;height: 40px; position: relative; z-index: 2;cursor: pointer;"
                                      class="form-control-sm">
                                      <option value="Abandon">Abandon</option>
                                    </select>

                                  </div>
                                </div> -->
                        <div class="col-12 col-lg-6">
                          <label class="shippn-form-label">
                            EEL or PFC Number
                          </label>
                          <input type="text" formControlName="eelOrPfcNumber"
                            [ngClass]="{'shippn-border-red':customsForm.get('eelOrPfcNumber').touched && customsForm.get('eelOrPfcNumber').invalid}"
                            placeholder="Required EEL or PFC Number for Customs"
                            class="form-control form-control-sm shippn-input" [attr.disabled]="isSelectsDisabled">
                        </div>
                      </div>
                      <div class="form-section-title" style="margin-top: 30px;" *ngIf="showSignatiure">
                        <h5 style="padding-left: 15px;">Signature*:</h5>
                      </div>
                      <div class="row" style="margin-bottom: 20px;" *ngIf="showSignatiure">
                        <div class="col-12 col-lg-6">
                          <label class="shippn-form-label"
                            style="display: flex; flex-direction: column; gap:5px; padding-bottom: 8px; ">
                            Signature
                            <sub style="color:#a8a8a8">Name-Surname</sub>
                          </label>
                          <input type="text" formControlName="signature"
                            [ngClass]="{'shippn-border-red':customsForm.get('signature').touched && customsForm.get('signature').invalid}"
                            placeholder="Your Signature" class="form-control form-control-sm shippn-input">

                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="col-12 col-md-5">
                    <h5>Package Contents:*</h5>

                    <div class="customs-package-contents-wrapper">
                      <div *ngFor="let customItem of customsForm.controls.customsItems.value; let index= index;"
                        class="customs-package-contents-item">
                        <div class="customs-package-content-item-header">
                          <h5>{{customItem.description}}</h5>
                          <div class="custom-item-actions-wrapper">
                            <button class="only-text-button border-rigt-text-button only-text-button-blue"
                              (click)="openEditCustomDialog(customItem, index)">Edit</button>
                            <button class="only-text-button only-text-button-red"
                              (click)="removeCustomsItem(index)">Remove</button>
                          </div>
                        </div>
                        <div class="custom-item-quantity-weight-value">
                          <div>
                            <label for="" class="customs-package-contents-item-label">Quantity:</label>
                            <h6>
                              {{customItem?.quantity}}
                            </h6>
                          </div>
                          <div>
                            <label for="" class="customs-package-contents-item-label">Weight:</label>
                            <h6>
                              {{customItem?.weight}} lbs
                            </h6>
                          </div>
                          <div>
                            <label for="" class="customs-package-contents-item-label">Value:</label>
                            <h6>
                              {{customItem?.value}} {{customItem.currency}}
                            </h6>
                          </div>

                        </div>
                        <div>
                          <label for="" class="customs-package-contents-item-label">Harmonized Tariff
                            Schedule:</label>
                          <h6>
                            {{customItem?.hs_tariff_number}}
                          </h6>
                        </div>

                        <div>
                          <label for="" class="customs-package-contents-item-label">Product Identifier:</label>
                          <h6>
                            {{customItem.productIdentifier}}
                          </h6>
                        </div>
                      </div>

                    </div>



                    <!-- Package Content List will be placed here  -->
                    <button class="btn b2b-create-shipment-add-btn" (click)="openDialog()"> <i class="fas fa-plus"></i>
                      Add
                      Item</button>
                  </div>
                </div>
              </div>
            </mat-step>
            <!-- Parcel & Label -->
            <mat-step [stepControl]="parcelAndLabelOptionsForm">
              <ng-template matStepLabel>
                Parcel & Label Options
              </ng-template>
              <div class="shippn-b2b-create-shipment-stepper-step-container">
                <form ngNativeValidate [formGroup]="parcelAndLabelOptionsForm">
                  <div class="row">
                    <div class="col-12 col-md-8">
                      <div class="form-section-title">
                        <h5 style="padding-left: 15px;">Parcel Information</h5>
                        <div style="margin-bottom: 15px;">
                          <span [matMenuTriggerFor]="aboveMenu"
                            style="font-size:14px;">{{parcelAndLabelOptionsForm.controls.dimensionUnit.value}}/
                            {{parcelAndLabelOptionsForm.controls.weightUnit.value}} <i class="fas fa-sort-down"
                              style="font-size: 16px;"></i></span>
                          <mat-menu #aboveMenu="matMenu" yPosition="below">
                            <ng-container>
                              <div class="dimension-and-weight-unit-menu">
                                <h6 class="dimension-and-weight-unit-menu-title">Measurements / Weight</h6>
                                <mat-radio-group aria-labelledby="measurments-radio-group-label"
                                  class="measurments-radio-group" formControlName="dimensionUnit">
                                  <mat-radio-button class="measurment-radio-button"
                                    *ngFor="let dimensionUnitIt of measurementsUnitsObJ"
                                    [value]="dimensionUnitIt.dimensionUnit"
                                    (click)="changeDimensionUnitOfParcelInformation(dimensionUnitIt)">
                                    {{dimensionUnitIt.dimensionUnit}} / {{dimensionUnitIt.weightUnit}}
                                  </mat-radio-button>
                                </mat-radio-group>
                              </div>
                            </ng-container>
                          </mat-menu>
                        </div>

                      </div>
                      <div class="row">
                        <div class="col-6 col-lg-3">
                          <label class="shippn-form-label">
                            Length
                          </label>
                          <div class="input-group">
                            <input type="number" formControlName="length"
                              [ngClass]="{'shippn-border-red':parcelAndLabelOptionsForm.get('length').touched && parcelAndLabelOptionsForm.get('length').invalid}"
                              placeholder="##"
                              class="form-control form-control-sm shippn-input parcel-information-input">
                            <div class="input-group-append">
                              <span class="input-group-text" style="font-size: 14px; padding: 5px;">
                                <span *ngIf="parcelAndLabelOptionsForm.controls.dimensionUnit.value == 'Inch'">in</span>
                                <span
                                  *ngIf="parcelAndLabelOptionsForm.controls.dimensionUnit.value == 'Centimeter'">cm</span>
                              </span>
                            </div>
                          </div>

                        </div>

                        <div class="col-6 col-lg-3">
                          <label class="shippn-form-label">
                            Width
                          </label>
                          <div class="input-group">
                            <input type="number" formControlName="width"
                              [ngClass]="{'shippn-border-red':parcelAndLabelOptionsForm.get('width').touched && parcelAndLabelOptionsForm.get('width').invalid}"
                              placeholder="##"
                              class="form-control form-control-sm shippn-input parcel-information-input">
                            <div class="input-group-append">
                              <span class="input-group-text" style="font-size: 14px; padding: 5px;">
                                <span *ngIf="parcelAndLabelOptionsForm.controls.dimensionUnit.value == 'Inch'">in</span>
                                <span
                                  *ngIf="parcelAndLabelOptionsForm.controls.dimensionUnit.value == 'Centimeter'">cm</span>
                              </span>
                            </div>
                          </div>

                        </div>

                        <div class="col-6 col-lg-3">
                          <label class="shippn-form-label">
                            Height
                          </label>
                          <div class="input-group">
                            <input type="number" formControlName="height"
                              [ngClass]="{'shippn-border-red':parcelAndLabelOptionsForm.get('height').touched && parcelAndLabelOptionsForm.get('height').invalid}"
                              placeholder="##"
                              class="form-control form-control-sm shippn-input parcel-information-input">
                            <div class="input-group-append">
                              <span class="input-group-text" style="font-size: 14px; padding: 5px;">
                                <span *ngIf="parcelAndLabelOptionsForm.controls.dimensionUnit.value == 'Inch'">in</span>
                                <span
                                  *ngIf="parcelAndLabelOptionsForm.controls.dimensionUnit.value == 'Centimeter'">cm</span>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="col-6 col-lg-3">
                          <label class="shippn-form-label">
                            Weight
                          </label>
                          <div class="input-group">
                            <input type="number" formControlName="weight"
                              [ngClass]="{'shippn-border-red':parcelAndLabelOptionsForm.get('weight').touched && parcelAndLabelOptionsForm.get('weight').invalid}"
                              placeholder="##"
                              class="form-control form-control-sm shippn-input parcel-information-input">
                            <div class="input-group-append">
                              <span class="input-group-text" style="font-size: 14px; padding: 5px;">
                                <span *ngIf="parcelAndLabelOptionsForm.controls.weightUnit.value == 'Ounce'">oz</span>
                                <span *ngIf="parcelAndLabelOptionsForm.controls.weightUnit.value == 'Pound'">lb</span>
                                <span *ngIf="parcelAndLabelOptionsForm.controls.weightUnit.value == 'Gram'">g</span>
                                <span
                                  *ngIf="parcelAndLabelOptionsForm.controls.weightUnit.value == 'Kilogram'">kg</span>
                              </span>
                            </div>
                          </div>

                        </div>
                      </div>
                      <div class="form-section-title" style="margin-top: 30px;">
                        <h5 style="padding-left: 15px;">Label Options</h5>
                      </div>

                      <div class="row">
                        <div class="col-12 col-lg-4">
                          <label class="shippn-form-label">
                            Label Format
                          </label>
                          <div style=" position: relative;">
                            <i class="fas fa-chevron-down"
                              style="display:none;position: absolute; right: 12px; top: 8px;float: right; color: #a8a8a8; border-radius: 32%; padding: 7px; font-size: 12px;"
                              aria-hidden="true"></i>
                            <select formControlName="labelFormat"
                              style="-webkit-appearance: none;-moz-appearance: none;appearance: none; width: 100%; border-radius: 5px;background-color: transparent;height: 40px; position: relative; z-index: 2;cursor: pointer;"
                              class="form-control-sm">
                              <option value="PDF">PDF</option>
                            </select>

                          </div>
                        </div>

                        <div class="col-12 col-lg-4">
                          <label class="shippn-form-label">
                            Reference ID
                          </label>
                          <input type="text" formControlName="referenceID"
                            [ngClass]="{'shippn-border-red':parcelAndLabelOptionsForm.get('referenceID').touched && parcelAndLabelOptionsForm.get('referenceID').invalid}"
                            placeholder="Reference ID" class="form-control form-control-sm shippn-input">

                        </div>
                        <div class="col-12 col-lg-4">
                          <label class="shippn-form-label">
                            Invoice Number
                          </label>
                          <input type="text" formControlName="invoiceNumber"
                            [ngClass]="{'shippn-border-red':parcelAndLabelOptionsForm.get('invoiceNumber').touched && parcelAndLabelOptionsForm.get('invoiceNumber').invalid}"
                            placeholder="Invoice Number" class="form-control form-control-sm shippn-input">

                        </div>

                      </div>
                    </div>
                    <div class="col-12 col-md-6">

                    </div>

                  </div>
                </form>
              </div>
            </mat-step>

            <mat-step *ngIf="comingFromContactus">
              <ng-template matStepLabel>Carrier & Service</ng-template>
              <div class="shippn-b2b-create-shipment-stepper-step-container">
                <div class="row">
                  <div class="col-12 col-md-8">
                    <h5> Select Carrier and Delivery Service</h5>
                    <div class="carrier-delivery-best-option" *ngIf="shipment_amounts.length > 0">
                      <div class="best-option-checkbox">
                        <input type="radio" (change)="changeCourier(shipment_amounts[0]['company_id'], 0)"
                          name="best_option" class="form-control-sm" id="best_option" [value]="0"
                          [checked]="bestOptionSelected">
                      </div>
                      <div class="best-option-best-available-label">
                        <label for="">Best Available</label>
                        <p>
                          {{shipment_amounts[0].company_name}}
                        </p>
                      </div>
                      <div class="best-option-service-level">
                        <label for="">Service Level</label>
                        <p>
                          {{shipment_amounts[0].service_type_name}}
                        </p>
                      </div>
                      <div class="best-option-transit-days">
                        <label for="">Transit Days</label>
                        <p>
                          {{shipment_amounts[0].estimated_delivery}}
                        </p>
                      </div>
                      <div class="best-option-your-cost">
                        <label for="">Your Cost</label>
                        <p *ngIf="+insuranceSelected == 0">
                          ${{shipment_amounts[0].amount}}
                        </p>
                        <p *ngIf="+insuranceSelected == 1">
                          ${{shipment_amounts[0].amount + insuranceAmount}}
                        </p>
                      </div>
                    </div>
                    <div class="card" style="box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);border: none;margin-top: 20px;"
                      *ngIf="shipment_amounts.length > 1">
                      <div style="background: #eaeaea;" class="card-header">
                        <h5 style="font-size: 16px;font-weight: 500;margin-bottom: 0;">More Options:</h5>
                      </div>
                      <div class="carrier-delivery-shipment-amounts-wrapper card-body">
                        <div class="carrier-delivery-shipment-amounts-header">
                          <h6 style="user-select: none;"></h6>
                          <h6>Carrier</h6>
                          <h6>Service Level</h6>
                          <h6>Transit Days</h6>
                          <h6>Your cost</h6>
                        </div>
                        <div class="carrier-delivery-shipment-amounts-list">
                          <div class="carrier-delivery-shipment-amounts-list"
                            *ngFor="let shipmentCompany of shipment_amounts; let i=index;">
                            <div class="carrier-delivery-shipment-amounts-list-item" *ngIf="i > 0">
                              <div
                                class="carrier-delivery-shipment-amounts-list-item-checkbox carrier-delivery-shipment-amounts-list-item-div">
                                <input type="radio" [name]="shipmentCompany?.company_id" class="form-control-sm"
                                  [id]="shipmentCompany?.company_id" [(ngModel)]="selectedCourier"
                                  (change)="changeCourier(shipmentCompany.company_id, i)" [value]="i">
                              </div>
                              <div
                                class="carrier-delivery-shipment-amounts-list-item-carrier carrier-delivery-shipment-amounts-list-item-div">
                                {{shipmentCompany.company_name}}
                              </div>
                              <div
                                class="carrier-delivery-shipment-amounts-list-item-service-level carrier-delivery-shipment-amounts-list-item-div">
                                {{shipmentCompany.service_type_name}}
                              </div>
                              <div
                                class="carrier-delivery-shipment-amounts-list-item-transit-days carrier-delivery-shipment-amounts-list-item-div">
                                {{shipmentCompany.estimated_delivery}}
                              </div>
                              <div
                                class="carrier-delivery-shipment-amounts-list-item-your-cost carrier-delivery-shipment-amounts-list-item-div">

                                <span *ngIf="+insuranceSelected == 0">
                                  ${{shipmentCompany.amount}}
                                </span>
                                <span *ngIf="+insuranceSelected == 1">
                                  ${{shipmentCompany.amount + insuranceAmount}}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);border: none;margin-top: 20px;"
                      class="card">
                      <div style="background: #eaeaea;" class="card-header">
                        <h5 style="font-size: 16px;font-weight: 500;margin-bottom: 0;">Insurance</h5>
                      </div>
                      <div class="card-body">
                        <p style="font-size: 14px;font-weight: 300;">
                          <span>
                            The insurance is calculated based on the total value of items in the shipment. 2
                            <span translate="no">USD</span> for each 100 <span translate="no">USD</span> of
                            items value at a minimum charge of 6 <span translate="no">USD</span>.
                            <br> <br>
                            Calculation
                            method may vary from carrier to carrier.<a
                              (click)="showInsuranceDetails = !showInsuranceDetails" style="color: blue; cursor:pointer"
                              class="desktop-show-detail">
                              <span *ngIf="showInsuranceDetails">Hide Details</span>
                              <span *ngIf="!showInsuranceDetails">View Details</span>
                              <br>
                            </a><br> <br>
                          </span>
                          <span *ngIf="showInsuranceDetails">
                            Shipment Value Protection helps you to get a full compensation for the declared
                            value of
                            your shipment in case the shipment gets lost or damaged in transit. Please refer our
                            <a [routerLink]="['/','terms']" target="_blank">Terms &
                              Conditions</a> for additional information.<br>
                          </span>
                          <a (click)="showInsuranceDetails = !showInsuranceDetails" style="color: blue; cursor:pointer"
                            class="mobile-show-detail">
                            <span *ngIf="showInsuranceDetails">Hide Details</span>
                            <span *ngIf="!showInsuranceDetails">View Details</span>
                            <br>
                          </a>
                        </p>
                        <div class="form-check">
                          <input (change)="changeInsurance()" class="form-check-input" [(ngModel)]="insuranceSelected"
                            type="radio" name="exampleRadios" id="exampleRadios1" value="1">
                          <label style="font-size: 14px;font-weight: 300;" class="form-check-label"
                            for="exampleRadios1">
                            I want to insure my shipment
                          </label>
                        </div>
                        <div class="form-check">
                          <input (change)="changeInsurance()" [(ngModel)]="insuranceSelected" class="form-check-input"
                            type="radio" name="exampleRadios" id="exampleRadios2" value="0">
                          <label style="font-size: 14px;font-weight: 300;" class="form-check-label"
                            for="exampleRadios2">
                            I do not want insurance on my shipment
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div style="box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);border: none;" class="card">
                      <div style="background: #eaeaea;" class="card-header">
                        <h5 style="font-size: 16px;font-weight: 500;margin-bottom: 0;">Shipping Charges</h5>
                      </div>
                      <div style="padding: 10px;" class="card-body">
                        <div class="table-responsive">
                          <table style="margin-bottom: 0;" class="table table-shipping-charges">
                            <tbody>
                              <tr>
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Shipping charge</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.amount |
                                    number:'1.2-2'}}
                                    USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.extended_area_amount > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;">Extended Area Fee</p>
                                    <ng-template #extentedAreaFee>
                                      <div style="text-align: left;">
                                        Applied by FedEx. <br>
                                        Applied for remote locations determined by Fedex
                                      </div>

                                    </ng-template>
                                    <div placement="top" [openDelay]="100" [closeDelay]="200"
                                      [ngbTooltip]="extentedAreaFee"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.extended_area_amount
                                    |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.restricted_destination_fee > 0">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Restricted Destination Fee</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.restricted_destination_fee |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.non_standart_pickup_fee > 0">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Non-standard Pickup Fee</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.non_standart_pickup_fee |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.additional_handling_surcharge > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;width: max-content;">Additional
                                      Handling Surcharge
                                    </p>
                                    <ng-template #additionalHandlingSurcharge>
                                      <div style="text-align: left;">
                                        Applied by FedEx. <br>
                                        Dimension <br>
                                        <ul style="padding-left: 20px;margin-bottom: 5px;">
                                          <li>Measures greater than 48 inches along its longest side;</li>
                                          <li>Measures greater than 30 inches along its second-longest
                                            side;</li>
                                          <li>Measures greater than 105 inches in length and girth</li>
                                        </ul>
                                        Weight <br>
                                        <ul style="padding-left: 20px;">
                                          <li>Has an actual weight greater than 70 lbs.</li>
                                        </ul>
                                      </div>

                                    </ng-template>
                                    <div placement="bottom" [openDelay]="100" [closeDelay]="200"
                                      [ngbTooltip]="additionalHandlingSurcharge"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>

                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.additional_handling_surcharge |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.peak_surcharge > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;width: max-content;">
                                      Peak Surcharge</p>
                                    <ng-template #dhlEss>
                                      <div style="text-align: left;">
                                        Applied by FedEx. <br>
                                      </div>
                                    </ng-template>
                                    <div placement="top" [openDelay]="100" [closeDelay]="200" [ngbTooltip]="dhlEss"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">{{selectedShipment?.peak_surcharge
                                    |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.emergency_situation_surcharge > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;width: max-content;">
                                      Emergency Situation Surcharge</p>
                                    <ng-template #dhlEss>
                                      <div style="text-align: left;">
                                        Applied by DHL. <br>
                                      </div>
                                    </ng-template>
                                    <div placement="top" [openDelay]="100" [closeDelay]="200" [ngbTooltip]="dhlEss"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.emergency_situation_surcharge |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.brexit_fee > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;width: max-content;">
                                      Brexit Adjustment Fee</p>
                                    <ng-template #residentalDeliveryCharge>
                                      <div style="text-align: left;">
                                        Applied by DHL. <br>
                                        Destination or Origin country U.K
                                      </div>
                                    </ng-template>
                                    <div placement="top" [openDelay]="100" [closeDelay]="200"
                                      [ngbTooltip]="residentalDeliveryCharge"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">{{selectedShipment?.brexit_fee |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.residential_delivery_charge > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;width: max-content;">
                                      Residential Delivery Charge</p>
                                    <ng-template #residentalDeliveryCharge>
                                      <div style="text-align: left;">
                                        Applied by FedEx. <br>
                                        Destination country Canada, and U.S. from all origin countries
                                      </div>

                                    </ng-template>
                                    <div placement="top" [openDelay]="100" [closeDelay]="200"
                                      [ngbTooltip]="residentalDeliveryCharge"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.residential_delivery_charge |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.oversize_package_fee > 0">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Oversize Package Fee</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.oversize_package_fee
                                    |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.export_declaration_fee > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;width: max-content;">
                                      Export Declaration Fee</p>
                                    <ng-template #declarationFee>
                                      <div style="text-align: left;">
                                        Applied by Customs in
                                        {{returnCountryName(selectedShipment?.b2b_user_address?.country)}}. <br>
                                      </div>
                                    </ng-template>
                                    <div placement="top" [openDelay]="100" [closeDelay]="200"
                                      [ngbTooltip]="declarationFee"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.export_declaration_fee |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="+insuranceSelected">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Insurance Amount</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    <span>
                                      {{insuranceAmount | number:'1.2-2'}}
                                    </span>
                                    USD
                                  </p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.elevated_risk_fee > 0">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Elevated Risk Fee</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;" translate="no">
                                  <p style="margin-bottom: 0;">{{selectedShipment?.elevated_risk_fee |
                                    number:'1.2-2'}}
                                    USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.repacking_service_fee > 0">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Repacking Service Fee</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.repacking_service_fee
                                    |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.storage_amount > 0">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Storage Fee</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">{{selectedShipment?.storage_amount
                                    |
                                    number:'1.2-2'}}
                                    USD</p>
                                </td>
                              </tr>
                              <tr>
                                <td style="padding-left: 0px;padding-bottom:0px;border-bottom: none;">
                                  <p style="margin-bottom: 0;font-weight: bold;font-size: 16px;">Total</p>
                                </td>
                                <td
                                  style="padding-right: 0px;padding-bottom:0px;text-align: right;border-bottom: none;">
                                  <p style="margin-bottom: 0;font-size: 16px;font-weight: bold;" translate="no"
                                    [ngStyle]="{'text-decoration': selectedShipment?.discount_amount > 0 ? 'line-through': 'none' }">
                                    <span *ngIf="+insuranceSelected == 0">
                                      {{selectedShipment?.amount | number:'1.2-2'}}
                                    </span><span *ngIf="+insuranceSelected == 1">
                                      {{(selectedShipment?.amount + insuranceAmount) |
                                      number:'1.2-2'}}
                                    </span> USD
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </mat-step>
            <!-- Carrier & Service & Payment -->
            <mat-step [stepControl]="paymentDone" *ngIf="!comingFromContactus">
              <ng-template matStepLabel>Carrier & Service</ng-template>

              <div class="shippn-b2b-create-shipment-stepper-step-container">
                <div class="row">
                  <div class="col-12 col-md-8">
                    <h5> Select Carrier and Delivery Service</h5>
                    <div class="carrier-delivery-best-option">
                      <div class="best-option-checkbox" *ngIf="shipment_amounts.length > 0">
                        <input type="radio" (change)="changeCourier(shipment_amounts[0]['company_id'], 0)"
                          name="best_option" class="form-control-sm" id="best_option" [value]="0"
                          [checked]="bestOptionSelected">
                      </div>
                      <div class="best-option-best-available-label">
                        <label for="">Best Available</label>
                        <p>
                          {{courierList[shipment_amounts[0].company_id]}}
                        </p>
                      </div>
                      <div class="best-option-service-level">
                        <label for="">Service Level</label>
                        <p>
                          {{shipment_amounts[0].service_type_name}}
                        </p>
                      </div>
                      <div class="best-option-transit-days">
                        <label for="">Transit Days</label>
                        <p>
                          {{shipment_amounts[0].estimated_delivery}}
                        </p>
                      </div>
                      <div class="best-option-your-cost">
                        <label for="">Your Cost</label>
                        <p *ngIf="+insuranceSelected == 0">
                          ${{shipment_amounts[0].total_shipment_amount}}
                        </p>
                        <p *ngIf="+insuranceSelected == 1">
                          ${{shipment_amounts[0].total_shipment_amount + insuranceAmount}}
                        </p>
                      </div>
                    </div>
                    <div class="card" style="box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);border: none;margin-top: 20px;"
                      *ngIf="shipment_amounts.length > 1">
                      <!-- <h6 class="shipment_amounts-wrapper-title card-heaer">More Options:</h6> -->
                      <div style="background: #eaeaea;" class="card-header">
                        <h5 style="font-size: 16px;font-weight: 500;margin-bottom: 0;">More Options:</h5>
                      </div>
                      <div class="carrier-delivery-shipment-amounts-wrapper card-body">
                        <div class="carrier-delivery-shipment-amounts-header">
                          <h6 style="user-select: none;"></h6>
                          <h6>Carrier</h6>
                          <h6>Service Level</h6>
                          <h6>Transit Days</h6>
                          <h6>Your cost</h6>
                        </div>
                        <div class="carrier-delivery-shipment-amounts-list">
                          <div class="carrier-delivery-shipment-amounts-list"
                            *ngFor="let shipmentCompany of shipment_amounts; let i=index;">
                            <div class="carrier-delivery-shipment-amounts-list-item" *ngIf="i > 0">
                              <div
                                class="carrier-delivery-shipment-amounts-list-item-checkbox carrier-delivery-shipment-amounts-list-item-div">
                                <input type="radio" [name]="shipmentCompany?.company_id" class="form-control-sm"
                                  [id]="shipmentCompany?.company_id" [(ngModel)]="selectedCourier"
                                  (change)="changeCourier(shipmentCompany.company_id, i)" [value]="i">
                              </div>
                              <div
                                class="carrier-delivery-shipment-amounts-list-item-carrier carrier-delivery-shipment-amounts-list-item-div">
                                {{courierList[shipmentCompany.company_id]}}
                              </div>
                              <div
                                class="carrier-delivery-shipment-amounts-list-item-service-level carrier-delivery-shipment-amounts-list-item-div">
                                {{shipmentCompany.service_type_name}}
                              </div>
                              <div
                                class="carrier-delivery-shipment-amounts-list-item-transit-days carrier-delivery-shipment-amounts-list-item-div">
                                {{shipmentCompany.estimated_delivery}}
                              </div>
                              <div
                                class="carrier-delivery-shipment-amounts-list-item-your-cost carrier-delivery-shipment-amounts-list-item-div">

                                <span *ngIf="+insuranceSelected == 0">
                                  ${{shipmentCompany.total_shipment_amount}}
                                </span>
                                <span *ngIf="+insuranceSelected == 1">
                                  ${{shipmentCompany.total_shipment_amount + insuranceAmount}}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);border: none;margin-top: 20px;"
                      class="card">
                      <div style="background: #eaeaea;" class="card-header">
                        <h5 style="font-size: 16px;font-weight: 500;margin-bottom: 0;">Insurance</h5>
                      </div>
                      <div class="card-body">
                        <p style="font-size: 14px;font-weight: 300;">
                          <span>
                            The insurance is calculated based on the total value of items in the shipment. 2
                            <span translate="no">USD</span> for each 100 <span translate="no">USD</span> of
                            items value at a minimum charge of 6 <span translate="no">USD</span>.
                            <br> <br>
                            Calculation
                            method may vary from carrier to carrier.<a
                              (click)="showInsuranceDetails = !showInsuranceDetails" style="color: blue; cursor:pointer"
                              class="desktop-show-detail">
                              <span *ngIf="showInsuranceDetails">Hide Details</span>
                              <span *ngIf="!showInsuranceDetails">View Details</span>
                              <br>
                            </a><br> <br>
                          </span>
                          <span *ngIf="showInsuranceDetails">
                            Shipment Value Protection helps you to get a full compensation for the declared
                            value of
                            your shipment in case the shipment gets lost or damaged in transit. Please refer our
                            <a [routerLink]="['/','terms']" target="_blank">Terms &
                              Conditions</a> for additional information.<br>
                          </span>
                          <a (click)="showInsuranceDetails = !showInsuranceDetails" style="color: blue; cursor:pointer"
                            class="mobile-show-detail">
                            <span *ngIf="showInsuranceDetails">Hide Details</span>
                            <span *ngIf="!showInsuranceDetails">View Details</span>
                            <br>
                          </a>
                        </p>
                        <div class="form-check">
                          <input (change)="changeInsurance()" class="form-check-input" [(ngModel)]="insuranceSelected"
                            type="radio" name="exampleRadios" id="exampleRadios1" value="1">
                          <label style="font-size: 14px;font-weight: 300;" class="form-check-label"
                            for="exampleRadios1">
                            I want to insure my shipment
                          </label>
                        </div>
                        <div class="form-check">
                          <input (change)="changeInsurance()" [(ngModel)]="insuranceSelected" class="form-check-input"
                            type="radio" name="exampleRadios" id="exampleRadios2" value="0">
                          <label style="font-size: 14px;font-weight: 300;" class="form-check-label"
                            for="exampleRadios2">
                            I do not want insurance on my shipment
                          </label>
                        </div>
                      </div>
                    </div>
                    <div
                      style="box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);border: none;margin-top: 20px; margin-bottom: 20px;"
                      class="card">
                      <div style="background: #eaeaea;" class="card-header">
                        <h5 style="font-size: 16px;font-weight: 500;margin-bottom: 0;">Payment</h5>
                      </div>
                      <div class="card-body payment-card">
                        <button id="hiddenAddCardModalOpener" data-toggle="modal" data-target="#addCardStartingModal"
                          style="display: none!important; visibility: hidden!important; height:0px!important; width: 0px!important;"></button>
                        <div class="row"
                          style="display: block; position:relative; padding: 0 15px; max-width: 600px; margin: auto;">
                          <div class="payment-method-chooser"
                            style="width: 100%;display: flex; flex-direction: column; padding: 0; gap:0;">
                            <!-- Stripe -->
                            <div style="border-bottom: 1px solid #e6e6e6;" class="col-md-12" id="stripe-box">
                              <div style="display: flex; align-items: center;"
                                (click)="scrollintoview('stripe-box'); paymentMethod = 'stripe'">
                                <button
                                  (click)="paymentMethod = 'stripe'; showAddCardForm = false; scrollintoview('stripe-box')"
                                  [ngClass]="paymentMethod == 'stripe' ? 'active' : ''"
                                  class="radio-inlie payment-method-radio"></button>
                                <span
                                  (click)="paymentMethod = 'stripe'; showAddCardForm = false; scrollintoview('stripe-box')"
                                  style="cursor: pointer;">Pay with 3D Secure / Klarna</span>
                              </div>
                              <!-- Via Stripe -->
                              <div class="row stripe--wrapper">
                                <div class="col-md-12" id="stripe--box" style="margin: auto;"
                                  [ngClass]="paymentMethod != 'stripe' ||  showAddCardForm ? 'hide-from-view' : ''">
                                  <!-- Display a payment form -->
                                  <form id="payment-form">
                                    <div id="payment-element-box">
                                      <div id="payment-element">
                                      </div>
                                    </div>
                                    <button id="submit" class="btn shippn-from-to-area-go-btn"
                                      style="width: calc(100% - 30px); margin-left: 15px;">
                                      <div class="spinner hidden" id="spinner"></div>
                                      <span id="button-text">CONFIRM ORDER</span>
                                    </button>
                                    <div id="payment-message" class="hidden"></div>
                                  </form>
                                </div>
                              </div>
                              <!-- Via Stripe -->
                            </div>
                            <!-- / Stripe -->
                            <!-- Credit Card-->
                            <div class="col-md-12" style="border-bottom: 1px solid #e6e6e6; margin-top:15px"
                              id="credit-card-box" *ngIf="userCreditCardDataArray.length > 0">
                              <div class="row">
                                <div style="text-align: left; display: flex; align-items: flex-start; padding:0;"
                                  class="col-md-7 card-text-area">
                                  <button
                                    (click)="paymentMethod = 'credit_card'; showAddCardForm = false; scrollintoview('credit-card-box')"
                                    [ngClass]="paymentMethod == 'credit_card' ? 'active' : ''"
                                    class="radio-inlie payment-method-radio"></button>
                                  <div
                                    (click)="paymentMethod = 'credit_card'; showAddCardForm = false;scrollintoview('credit-card-box')"
                                    style="cursor: pointer;">
                                    <div class="card-number-area" style="margin-top: -4px;">
                                      Pay with Saved Cards <br />
                                      <span>***********<span *ngIf="selectedCreditCard?.card_no_masked.length - 4 == 12">*</span></span>
                                      <span translate="no">{{selectedCreditCard?.card_no_masked | slice:-4}}</span>
                                    </div>
                                    <div class="card-status-area" style="margin-top: -10px;">
                                      <span *ngIf="selectedCreditCard?.status == 3"
                                        style="font-size: 11px;">Verified</span>
                                      <span *ngIf="selectedCreditCard?.payment_method_id" style="font-size: 11px;"> with
                                        3D
                                        secure</span>
                                      <span
                                        *ngIf="selectedCreditCard?.status == 4 || (selectedCreditCard?.status == 2 && selectedCreditCard?.verification_attempts >= 2) || (selectedCreditCard?.status == 1 && selectedCreditCard?.verification_attempts >= 2)"
                                        style="font-size: 11px;">Failed
                                        Verification</span>
                                      <span
                                        *ngIf="selectedCreditCard?.status == 0 || selectedCreditCard?.status == 1 || (selectedCreditCard?.status == 2 && selectedCreditCard?.verification_attempts < 2)"
                                        style="font-size: 11px;">Unverified</span>
                                    </div>

                                  </div>
                                </div>
                                <div class="col-md-5 card-change-area" style="text-align: right; padding-right: 30px;">
                                  <button class="btn" data-toggle="modal" data-target="#changeCreditCardModal"
                                    data-backdrop="static" data-keyboard="false"
                                    style="border: 1px solid #ff6c36; color:#ff6c36;"
                                    *ngIf="paymentMethod == 'credit_card'">
                                    Change
                                  </button>
                                </div>
                                <div class="clearfix"></div>
                                <div style="margin:20px auto;" class="col-md-12">
                                  <button
                                    *ngIf="!isLoading && !showAddCardForm && selectedCreditCard?.status == 3 && paymentMethod == 'credit_card'"
                                    (click)="confirmOrder()"
                                    style="width: calc(100% - 30px); margin-left: 15px;font-size: 16px; height: 38px;"
                                    class="btn shippn-from-to-area-go-btn"
                                    [disabled]="showAddCardForm || !selectedCreditCard || paymentMethod != 'credit_card'">CONFIRM
                                    ORDER</button>
                                  <button
                                    *ngIf="selectedCreditCard?.status == 3 && isLoading == true && !showAddCardForm && paymentMethod == 'credit_card'"
                                    style="background-image: url(../../assets/img/loading-white.gif);background-repeat: no-repeat;background-position: center;width: calc(100% - 30px); margin-left: 15px; height: 38px;"
                                    class="btn shippn-from-to-area-go-btn"></button>
                                </div>
                                <div class="col-md-12"
                                  *ngIf="selectedCreditCard != null && selectedCreditCard.status != 3 && paymentMethod == 'credit_card'">
                                  <p style="padding: 0 15px; font-size: 14px;">
                                    You have added a new card. <br />
                                    We need to verify this card before it can be used on Shippn. <br />
                                    We have charged <strong translate="no">$0.50</strong> to this card.
                                    <br /> <br />
                                    You will see this charge as <strong translate="no">"SHIPPN*
                                      XXXX-CODE"</strong> on
                                    your credit card
                                    statement.
                                  </p>
                                  <div
                                    *ngIf="selectedCreditCard != null && selectedCreditCard.status != 3 && paymentMethod == 'credit_card'">
                                    <div class="row">
                                      <div class="col-md-12 otp-wrapper-fixer">
                                        <div>
                                          <div style="margin-top: 10px; margin-bottom: 20px;"
                                            *ngIf="selectedCreditCard != null && selectedCreditCard.status != 3"
                                            class="card">
                                            <div class="card-header">
                                              <div style="display: inline-flex;align-items: center;float: left;">
                                                <span class="pull-right"><strong
                                                    style="margin-right: 5px;" translate="no">{{selectedCreditCard?.card_no_masked}}</strong>({{selectedCreditCard?.brand}})</span>
                                              </div>
                                              <button style="float: right;" class="btn btn-danger btn-sm"
                                                data-toggle="modal" data-target="#deleteCreditCard">Delete</button>
                                              <!-- Modal -->
                                              <div class="modal fade" id="deleteCreditCard" tabindex="-1"
                                                aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                <div class="modal-dialog modal-dialog-centered">
                                                  <div class="modal-content">
                                                    <div class="modal-header">
                                                      <h5 class="modal-title" id="exampleModalLabel">Are you
                                                        sure?
                                                      </h5>
                                                      <button type="button" class="close" data-dismiss="modal"
                                                        aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                      </button>
                                                    </div>
                                                    <div class="modal-body">
                                                      <p
                                                        style="color: black;text-align: center;font-size: 16px;font-weight: 300;margin-bottom: 5px;">
                                                        Are you sure to delete your
                                                        <strong>{{selectedCreditCard?.brand}}</strong>
                                                        credit
                                                        card:
                                                        <strong translate="no">{{selectedCreditCard?.card_no_masked}}</strong>
                                                      </p>
                                                    </div>
                                                    <div class="modal-footer">
                                                      <button type="button" class="btn btn-secondary"
                                                        data-dismiss="modal">Close</button>
                                                      <button style="float: right;" class="btn btn-danger"
                                                        data-dismiss="modal"
                                                        (click)="deleteCreditCard(selectedCreditCard)">Delete</button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="card-body" *ngIf="selectedCreditCard">
                                              <div *ngIf="selectedCreditCard?.status==0">
                                                <button style="font-size: 16px;font-weight: bold;height: 45px;"
                                                  (click)="startCardVerifyStatusZero(selectedCreditCard)"
                                                  class="btn shippn-from-to-area-go-btn">CONFIRM
                                                  VERIFICATION
                                                  AMOUNT</button>
                                              </div>
                                              <div *ngIf="selectedCreditCard?.status==1">
                                                <form ngNativeValidate [formGroup]="cardVerifyForm">
                                                  <div class="row">
                                                    <div class="col-md-12">
                                                      <p
                                                        style="color: #dc3545;text-align: center;font-size: 16px;font-weight: 600;margin-bottom: 5px;">
                                                        Please enter the Verification Code
                                                        by checking this
                                                        charge from your bank. <br />
                                                        You will see this charge as
                                                        "SHIPPN* XXXX-CODE" on your credit
                                                        card statement.</p>
                                                    </div>


                                                    <div class="col-12 col-lg-8" style="margin: auto;">
                                                      <div id="otp"
                                                        class="inputs d-flex flex-row justify-content-center mt-2 otpInputsWrapper">
                                                        <div class="otp-pointer">
                                                          <h4>
                                                            SHIPPN*
                                                          </h4>
                                                        </div>
                                                        <input formControlName="otpInput1"
                                                          onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                                                          class="text-center form-control rounded otpInputC" type="text"
                                                          id="otpInput1" maxlength="1"
                                                          (keyup)="onKeyPresOTP($event, 1)" />
                                                        <input formControlName="otpInput2"
                                                          onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                                                          class="text-center form-control rounded otpInputC" type="text"
                                                          id="otpInput2" maxlength="1"
                                                          (keyup)="onKeyPresOTP($event, 2)" />
                                                        <input formControlName="otpInput3"
                                                          onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                                                          class="text-center form-control rounded otpInputC" type="text"
                                                          id="otpInput3" maxlength="1"
                                                          (keyup)="onKeyPresOTP($event, 3)" />
                                                        <input formControlName="otpInput4"
                                                          onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                                                          class="text-center form-control rounded otpInputC" type="text"
                                                          id="otpInput4" maxlength="1"
                                                          (keyup)="onKeyPresOTP($event, 4)" />
                                                        <div class="otp-pointer">
                                                          <h4>
                                                            -CODE
                                                          </h4>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="col-md-12 text-center" style="margin-top: 5px;">
                                                      <p style="padding: 10px; margin: 0;">
                                                        <span
                                                          style="font-size: 20px;font-weight: 900; color: #f66c37">{{
                                                          2 -
                                                          selectedCreditCard.verification_attempts}}</span>
                                                        attempts left
                                                      </p>
                                                    </div>
                                                    <div class="col-md-12 text-center">
                                                      <button style="font-size: 16px;font-weight: bold;height: 45px;"
                                                        (click)="startCardVerifyStatusOne(selectedCreditCard)"
                                                        class="btn shippn-from-to-area-go-btn">Confirm
                                                        Verification Code</button>
                                                    </div>
                                                  </div>
                                                </form>
                                              </div>
                                              <div
                                                *ngIf="selectedCreditCard?.status == 4 || (selectedCreditCard?.status == 2 && selectedCreditCard?.verification_attempts >= 2) || (selectedCreditCard?.status == 2 && selectedCreditCard?.verification_attempts >= 2)">
                                                <h4>
                                                  Failed Verification
                                                </h4>
                                                <p>
                                                  Please add another payment method or contact <a
                                                    href="/contact-us">Shippn
                                                    Support</a> for
                                                  further assistance.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Add Card -->
                            <div style="margin-top: 15px; border-bottom: 1px solid #e6e6e6;" class="col-md-12"
                              id="add-card-box">
                              <button [disabled]="paymentMethod == 'Add_Card'"
                                style="background: transparent; border:0; padding-left: 0;"
                                (click)="paymentMethod = 'Add_Card';showAddCardForm = true;scrollintoview('add-card-box', true);showAddCardModal();"
                                data-toggle="modal" data-target="#addCardStartingModal" id="addCardSectionButton">
                                <i class="fas fa-plus">
                                </i>
                                <span style="margin-left: 4px;">Add a Credit Card</span>
                              </button>
                              <!-- Add Credit Card -->
                              <!-- Credit Card-->
                              <div class="row">
                                <!-- Add Card Form -->
                                <div style="text-align: center;margin-bottom: 40px;" class="col-md-12">
                                  <!-- Card Add Form -->
                                  <div style="max-width: 600px;margin-left: auto;margin-right: auto;"
                                    *ngIf="showAddCardForm">
                                    <div>
                                      <div class="credit-card-container preload">
                                        <div style="transition: transform 0.6s !important;"
                                          [ngClass]="{'flipped':!isShowCardFront}" class="creditcard">
                                          <div (click)="changeCardFlip('back')" class="front">
                                            <div id="ccsingle"></div>
                                            <svg version="1.1" id="cardfront" xmlns="http://www.w3.org/2000/svg"
                                              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                              viewBox="0 0 750 471" style="enable-background:new 0 0 750 471;"
                                              xml:space="preserve">
                                              <g id="Front">
                                                <g id="CardBackground">
                                                  <g id="Page-1_1_">
                                                    <g id="amex_1_">
                                                      <path id="Rectangle-1_1_" class="lightcolor grey" d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                                                  C0,17.9,17.9,0,40,0z" />
                                                    </g>
                                                  </g>
                                                  <path class="darkcolor greydark"
                                                    d="M750,431V193.2c-217.6-57.5-556.4-13.5-750,24.9V431c0,22.1,17.9,40,40,40h670C732.1,471,750,453.1,750,431z" />
                                                </g>
                                                <text transform="matrix(1 0 0 1 60.106 295.0121)" id="svgnumber"
                                                  class="st2 st3 st4">{{creditCardForm.value.cardNumber}}</text>
                                                <text transform="matrix(1 0 0 1 54.1064 428.1723)" id="svgname"
                                                  class="st2 st5 st6"
                                                  translate="no">{{creditCardForm.value.nameOnCard}}</text>
                                                <text transform="matrix(1 0 0 1 54.1074 389.8793)" class="st7 st5 st8"
                                                  translate="no">cardholder
                                                  name</text>
                                                <text transform="matrix(1 0 0 1 479.7754 388.8793)"
                                                  class="st7 st5 st8">expiration</text>
                                                <text transform="matrix(1 0 0 1 65.1054 241.5)" class="st7 st5 st8">card
                                                  number</text>
                                                <g>
                                                  <text transform="matrix(1 0 0 1 574.4219 433.8095)" id="svgexpire"
                                                    class="st2 st5 st9">{{creditCardForm.value.validThruMonth}}/{{creditCardForm.value.validThruYear}}</text>
                                                  <text transform="matrix(1 0 0 1 479.3848 417.0097)"
                                                    class="st2 st10 st11">VALID</text>
                                                  <text transform="matrix(1 0 0 1 479.3848 435.6762)"
                                                    class="st2 st10 st11">THRU</text>
                                                  <polygon class="st2" points="554.5,421 540.4,414.2 540.4,427.9 		" />
                                                </g>
                                                <g id="cchip">
                                                  <g>
                                                    <path class="st2" d="M168.1,143.6H82.9c-10.2,0-18.5-8.3-18.5-18.5V74.9c0-10.2,8.3-18.5,18.5-18.5h85.3
                                              c10.2,0,18.5,8.3,18.5,18.5v50.2C186.6,135.3,178.3,143.6,168.1,143.6z" />
                                                  </g>
                                                  <g>
                                                    <g>
                                                      <rect x="82" y="70" class="st12" width="1.5" height="60" />
                                                    </g>
                                                    <g>
                                                      <rect x="167.4" y="70" class="st12" width="1.5" height="60" />
                                                    </g>
                                                    <g>
                                                      <path class="st12" d="M125.5,130.8c-10.2,0-18.5-8.3-18.5-18.5c0-4.6,1.7-8.9,4.7-12.3c-3-3.4-4.7-7.7-4.7-12.3
                                                  c0-10.2,8.3-18.5,18.5-18.5s18.5,8.3,18.5,18.5c0,4.6-1.7,8.9-4.7,12.3c3,3.4,4.7,7.7,4.7,12.3
                                                  C143.9,122.5,135.7,130.8,125.5,130.8z M125.5,70.8c-9.3,0-16.9,7.6-16.9,16.9c0,4.4,1.7,8.6,4.8,11.8l0.5,0.5l-0.5,0.5
                                                  c-3.1,3.2-4.8,7.4-4.8,11.8c0,9.3,7.6,16.9,16.9,16.9s16.9-7.6,16.9-16.9c0-4.4-1.7-8.6-4.8-11.8l-0.5-0.5l0.5-0.5
                                                  c3.1-3.2,4.8-7.4,4.8-11.8C142.4,78.4,134.8,70.8,125.5,70.8z" />
                                                    </g>
                                                    <g>
                                                      <rect x="82.8" y="82.1" class="st12" width="25.8" height="1.5" />
                                                    </g>
                                                    <g>
                                                      <rect x="82.8" y="117.9" class="st12" width="26.1" height="1.5" />
                                                    </g>
                                                    <g>
                                                      <rect x="142.4" y="82.1" class="st12" width="25.8" height="1.5" />
                                                    </g>
                                                    <g>
                                                      <rect x="142" y="117.9" class="st12" width="26.2" height="1.5" />
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                              <g id="Back">
                                              </g>
                                            </svg>
                                          </div>
                                          <div (click)="changeCardFlip('front')" class="back">
                                            <svg version="1.1" id="cardback" xmlns="http://www.w3.org/2000/svg"
                                              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                              viewBox="0 0 750 471" style="enable-background:new 0 0 750 471;"
                                              xml:space="preserve">
                                              <g id="Front">
                                                <line class="st0" x1="35.3" y1="10.4" x2="36.7" y2="11" />
                                              </g>
                                              <g id="Back">
                                                <g id="Page-1_2_">
                                                  <g id="amex_2_">
                                                    <path id="Rectangle-1_2_" class="darkcolor greydark" d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                                              C0,17.9,17.9,0,40,0z" />
                                                  </g>
                                                </g>
                                                <rect y="61.6" class="st2" width="750" height="78" />
                                                <g>
                                                  <path class="st3" d="M701.1,249.1H48.9c-3.3,0-6-2.7-6-6v-52.5c0-3.3,2.7-6,6-6h652.1c3.3,0,6,2.7,6,6v52.5
                                          C707.1,246.4,704.4,249.1,701.1,249.1z" />
                                                  <rect x="42.9" y="198.6" class="st4" width="664.1" height="10.5" />
                                                  <rect x="42.9" y="224.5" class="st4" width="664.1" height="10.5" />
                                                  <path class="st5"
                                                    d="M701.1,184.6H618h-8h-10v64.5h10h8h83.1c3.3,0,6-2.7,6-6v-52.5C707.1,187.3,704.4,184.6,701.1,184.6z" />
                                                </g>
                                                <text transform="matrix(1 0 0 1 621.999 227.2734)" id="svgsecurity"
                                                  class="st6 st7">{{creditCardForm.value.securityCode}}</text>
                                                <g class="st8">
                                                  <text transform="matrix(1 0 0 1 518.083 280.0879)"
                                                    class="st9 st6 st10">security code</text>
                                                </g>
                                                <rect x="58.1" y="378.6" class="st11" width="375.5" height="13.5" />
                                                <rect x="58.1" y="405.6" class="st11" width="421.7" height="13.5" />
                                                <text transform="matrix(1 0 0 1 59.5073 228.6099)" id="svgnameback"
                                                  class="st12 st13"
                                                  translate="no">{{creditCardForm.value.nameOnCard}}</text>
                                              </g>
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row"
                                      style=" max-width: 360px; margin: 20px auto 0!important; padding-left: 0!important; display: flex; justify-content: space-between;">
                                      <div
                                        style="display: flex; justify-content: space-between; padding-left: 0!important;"
                                        class="col-md-9 col-9">
                                        <img style="width: 14%;"
                                          src="../assets/img/svg-original-colors/payment-visa.svg"
                                          alt="Shippn payment Visa logo">
                                        <img style="width: 14%;"
                                          src="../assets/img/svg-original-colors/payment-paypal.svg"
                                          alt="Shippn payment Paypal logo">
                                        <img style="width:14%;"
                                          src="../assets/img/svg-original-colors/payment-american-express.svg"
                                          alt="Shippn payment American Express logo">
                                        <img style="width:14%;"
                                          src="../assets/img/svg-original-colors/payment-discover_card_logo.svg"
                                          alt="Shippn payment Discover Card logo">
                                        <img style="width: 14%;"
                                          src="../assets/img/svg-original-colors/payment-mastercard-logo.svg"
                                          alt="Shippn payment Mastercard logo">
                                      </div>
                                      <div style="text-align: center;display: flex; padding: 0;" class="col-md-3 col-3">
                                        <img style="width: 100%;"
                                          src="../assets/img/svg-original-colors/powered-by-stripe.svg"
                                          alt="Shippn payment Powered by stripe logo badge">
                                      </div>
                                    </div>
                                    <!-- Add Card Form-->
                                    <form ngNativeValidate [formGroup]="creditCardForm"
                                      style="max-width: 360px; margin: auto;">
                                      <div class="row">
                                        <div style="margin-top: 15px;" class="col-12 col-lg-12">
                                          <p
                                            style="color: black;text-align: left;font-size: 14px;font-weight: normal;margin-bottom: 0px;">
                                            Name on
                                            Card</p>
                                          <input (click)="changeCardFlip('front')"
                                            style="background-color: white !important;" type="text"
                                            formControlName="nameOnCard"
                                            [ngClass]="{'shippn-border-red':creditCardForm.get('nameOnCard').touched && creditCardForm.get('nameOnCard').invalid}"
                                            placeholder="Name on Card"
                                            class="form-control form-control-sm shippn-input addCardFormInput">
                                        </div>
                                        <div style="margin-top: 15px;" class="col-12 col-lg-12">
                                          <p
                                            style="color: black;text-align: left;font-size: 14px;font-weight: normal;margin-bottom: 0px;">
                                            Card
                                            Number</p>
                                          <input (click)="changeCardFlip('front')"
                                            style="background-color: white !important;" type="text"
                                            formControlName="cardNumber" maxlength="16"
                                            [ngClass]="{'shippn-border-red':creditCardForm.get('cardNumber').touched && creditCardForm.get('cardNumber').invalid}"
                                            placeholder="1111 2222 3333 4444"
                                            class="form-control form-control-sm shippn-input addCardFormInput">
                                        </div>
                                        <div style="margin-top: 15px;" class="col-md-6">
                                          <div class="row">
                                            <p
                                              style="width:100%;color: black;text-align: left;font-size: 14px;font-weight: normal;margin-bottom: 5px;">
                                              Valid Thru</p>
                                            <div class="col-12 col-lg-6" style="padding-left: 0;">

                                              <div class="select--wrapper">
                                                <i class="fas fa-chevron-down"
                                                  style="position: absolute; right: 8px; top: 16px;float: right; color: #222222;font-size: 12px;"
                                                  aria-hidden="true"></i>
                                                <select (click)="changeCardFlip('front')"
                                                  formControlName="validThruMonth"
                                                  style="margin-bottom: 0px; width: 100%; border-radius: 5px;height:42px;"
                                                  class="form-control-sm addCardFormSelect">
                                                  <option selected value="01">01</option>
                                                  <option value="02">02</option>
                                                  <option value="03">03</option>
                                                  <option value="04">04</option>
                                                  <option value="05">05</option>
                                                  <option value="06">06</option>
                                                  <option value="07">07</option>
                                                  <option value="08">08</option>
                                                  <option value="09">09</option>
                                                  <option value="10">10</option>
                                                  <option value="11">11</option>
                                                  <option value="12">12</option>
                                                </select>
                                              </div>
                                            </div>
                                            <div class="col-12 col-lg-6 desktop-valid-year-pad">
                                              <div class="select--wrapper">
                                                <i class="fas fa-chevron-down"
                                                  style="position: absolute; right: 8px; top: 18px;float: right; color: #222222;font-size: 12px;"
                                                  aria-hidden="true"></i>
                                                <select (click)="changeCardFlip('front')"
                                                  formControlName="validThruYear"
                                                  style="margin-bottom: 2px; width: 100%; border-radius: 5px;height:42px;"
                                                  class="form-control-sm addCardFormSelect">
                                                  <option selected value="2022">2022</option>
                                                  <option value="2023">2023</option>
                                                  <option value="2024">2024</option>
                                                  <option value="2025">2025</option>
                                                  <option value="2026">2026</option>
                                                  <option value="2027">2027</option>
                                                  <option value="2028">2028</option>
                                                  <option value="2029">2029</option>
                                                  <option value="2030">2030</option>
                                                  <option value="2031">2031</option>
                                                  <option value="2032">2032</option>
                                                  <option value="2033">2033</option>
                                                  <option value="2034">2034</option>
                                                </select>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div style="margin-top: 15px;" class="col-md-6">
                                          <p
                                            style="color: black;text-align: left;font-size: 14px;font-weight: normal;margin-bottom: 0px;">
                                            Security Code</p>
                                          <input (click)="changeCardFlip('back')"
                                            style="background-color: white !important;" maxlength="4" type="text"
                                            formControlName="securityCode"
                                            [ngClass]="{'shippn-border-red':creditCardForm.get('securityCode').touched && creditCardForm.get('securityCode').invalid}"
                                            placeholder="CVC/CCV"
                                            class="form-control form-control-sm shippn-input addCardFormInput">
                                        </div>
                                        <div style="margin-top: 20px;" class="col-12">
                                          <button *ngIf="!isLoading"
                                            style="width: 100%;font-size: 16px;font-weight: bold;height: 45px;"
                                            (click)="addNewCard()" class="btn shippn-from-to-area-go-btn">ADD
                                            CARD</button>
                                          <button *ngIf="isLoading"
                                            style="background-image: url(../../assets/img/loading-white.gif);background-repeat: no-repeat;background-position: center;height: 45px;width: 100%;"
                                            class="btn shippn-from-to-area-go-btn"></button>
                                          <button
                                            style="width: 100%;font-size: 16px;font-weight: bold;height: 45px;background-color: #c9c9c9 !important;border-color: #c9c9c9 !important;margin-top: 10px;"
                                            (click)="showAddCardForm = false; paymentMethod = 'stripe'; scrollintoview('stripe-box')"
                                            class="btn shippn-from-to-area-go-btn">CANCEL</button>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                              <!-- Credit Card -->
                              <!-- Add Credit Card -->
                            </div>
                            <!-- / Add Card -->
                            <!-- Paypal -->
                            <div style="margin-top: 20px; border-bottom: 1px solid #e6e6e6;" class="col-md-12"
                              id="paypal-box">
                              <div style="display: flex; align-items: center;" (click)="scrollintoview('paypal-box')">
                                <button
                                  (click)="paymentMethod = 'paypal'; showAddCardForm = false; scrollintoview('paypal-box')"
                                  [ngClass]="paymentMethod == 'paypal' ? 'active' : ''"
                                  class="radio-inlie payment-method-radio"></button>
                                <span
                                  (click)="paymentMethod = 'paypal'; showAddCardForm = false; scrollintoview('paypal-box')"
                                  style="cursor: pointer;">Pay with PayPal</span>
                              </div>
                              <div style="margin-top: 20px;">
                                <!-- Paypal-->
                                <div class="paypal-wrapper" style="margin-bottom: 20px;"
                                  [ngClass]="paymentMethod != 'paypal' ||  showAddCardForm ? 'hide-from-view' : ''">
                                  <div class="row">
                                    <div class="col-md-12 verification-status-display-text">
                                      <div class="col-md-6"
                                        [ngClass]="!isPaypalPaymentValidation ? 'paypal-active-text' : ' paypal-inactive-text'">
                                        Verify your PayPal account
                                      </div>
                                      <div class="col-md-6"
                                        [ngClass]="isPaypalPaymentValidation ? 'paypal-active-text' : ' paypal-inactive-text'">
                                        Checkout with PayPal
                                      </div>
                                    </div>
                                    <div class="col-md-12 verification-status-display-icon">
                                      <i class="far "
                                        [ngClass]="!isPaypalPaymentValidation ? 'icon-color-red fa-times-circle ' : ' icon-color-green fa-check-circle' "></i>
                                      <div class="just-line"></div>
                                      <i class="far fa-circle" [ngClass]="isPaypalPaymentValidation ? '' : '' "></i>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6 mobile-mt-10"
                                      [ngClass]="isPaypalPaymentValidation ? 'disabled' : '' ">
                                      <!-- Add Paypal Account -->
                                      <button class="btn btn-login-paypal"
                                        style="height: 42px; max-height: 42px; padding: 0;">
                                        <p *ngIf="isPaypalPaymentValidation">
                                          <!-- Login with PayPal -->
                                          <img src="../../../assets/img/payment-paypal-btn-placeholder.svg"
                                            alt="paypal button placeholder" style="max-width: 60px;">
                                        </p>
                                        <ngx-paypal [config]="payPalConfigTwo" *ngIf="!isPaypalPaymentValidation"
                                          style="max-height: 42px; min-width: 100%;"></ngx-paypal>
                                      </button>
                                      <p *ngIf="!isPaypalPaymentValidation" style="font-size: 10px; color: #707070;">
                                        <span *ngIf="!payPalErrorMessage">
                                          You will be charged 0.50 <span translate="no">USD</span> to
                                          verify your payment method. This
                                          will be refundend
                                          back to
                                          you
                                          once verification is completed. You won't be charged for
                                          anything at this time.
                                        </span>
                                        <span *ngIf="payPalErrorMessage">
                                          {{payPalErrorMessage}}
                                        </span>
                                      </p>
                                      <p *ngIf="isPaypalPaymentValidation" style="font-size: 10px; color: #707070;">
                                        You have successfully verified your PayPal account.
                                      </p>
                                    </div>
                                    <div class="col-md-6 mobile-mt-10"
                                      [ngClass]="isPaypalPaymentValidation ? '' : 'disabled' ">
                                      <button class="btn btn-paypal-verified"
                                        style="height: 42px; max-height: 42px; padding: 0;">
                                        <p *ngIf="!isPaypalPaymentValidation">
                                          <img src="../../../assets/img/payment-paypal-btn-placeholder.svg"
                                            alt="paypal button placeholder" style="max-width: 60px;">
                                        </p>
                                        <ngx-paypal [config]="payPalConfig" *ngIf="isPaypalPaymentValidation"
                                          style="min-width: 100%; max-height: 42px;">
                                        </ngx-paypal>
                                      </button>
                                      <p *ngIf="!isPaypalPaymentValidation" style="font-size: 10px; color: #707070;">
                                        Once your account verification completed, you can checkout with your
                                        PayPal account.
                                      </p>
                                      <p *ngIf="isPaypalPaymentValidation" style="font-size: 10px; color: #707070;">
                                        You can now checkout with your verified PayPal account.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <!-- Paypal -->
                              </div>
                            </div>
                            <!-- / PayPal -->
                            <div class="col-md-12" style="margin-top: 20px;" id="googlePay-box">
                              <div style="display: flex; align-items: center;"
                                (click)="scrollintoview('googlePay-box');">
                                <button
                                  (click)="paymentMethod = 'googlePay'; showAddCardForm = false; scrollintoview('googlePay-box')"
                                  [ngClass]="paymentMethod == 'googlePay' ? 'active' : ''"
                                  class="radio-inlie payment-method-radio"></button>
                                <span
                                  (click)="paymentMethod = 'googlePay'; showAddCardForm = false; scrollintoview('googlePay-box')"
                                  style="cursor: pointer;">Pay with Google Pay</span>
                              </div>
                              <div id="googlePay-button-wrapper" class="Google-pay"
                                [ngClass]="paymentMethod != 'googlePay' ||  showAddCardForm ? 'hide-from-view' : ''">
                                <div id="payment-request-button">
                                  <!-- A Stripe Element will be inserted here. -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div style="box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);border: none;" class="card">
                      <div style="background: #eaeaea;" class="card-header">
                        <h5 style="font-size: 16px;font-weight: 500;margin-bottom: 0;">Shipping Charges</h5>
                      </div>
                      <div style="padding: 10px;" class="card-body">
                        <div class="table-responsive">
                          <table style="margin-bottom: 0;" class="table table-shipping-charges">
                            <tbody>
                              <tr>
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Shipping charge</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.shipment_amount |
                                    number:'1.2-2'}}
                                    USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.extended_area_amount > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;">Extended Area Fee</p>
                                    <ng-template #extentedAreaFee>
                                      <div style="text-align: left;">
                                        Applied by FedEx. <br>
                                        Applied for remote locations determined by Fedex
                                      </div>

                                    </ng-template>
                                    <div placement="top" [openDelay]="100" [closeDelay]="200"
                                      [ngbTooltip]="extentedAreaFee"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.extended_area_amount
                                    |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.restricted_destination_fee > 0">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Restricted Destination Fee</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.restricted_destination_fee |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.non_standart_pickup_fee > 0">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Non-standard Pickup Fee</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.non_standart_pickup_fee |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.additional_handling_surcharge > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;width: max-content;">Additional
                                      Handling Surcharge
                                    </p>
                                    <ng-template #additionalHandlingSurcharge>
                                      <div style="text-align: left;">
                                        Applied by FedEx. <br>
                                        Dimension <br>
                                        <ul style="padding-left: 20px;margin-bottom: 5px;">
                                          <li>Measures greater than 48 inches along its longest side;</li>
                                          <li>Measures greater than 30 inches along its second-longest
                                            side;</li>
                                          <li>Measures greater than 105 inches in length and girth</li>
                                        </ul>
                                        Weight <br>
                                        <ul style="padding-left: 20px;">
                                          <li>Has an actual weight greater than 70 lbs.</li>
                                        </ul>
                                      </div>

                                    </ng-template>
                                    <div placement="bottom" [openDelay]="100" [closeDelay]="200"
                                      [ngbTooltip]="additionalHandlingSurcharge"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>

                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.additional_handling_surcharge |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.peak_surcharge > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;width: max-content;">
                                      Peak Surcharge</p>
                                    <ng-template #dhlEss>
                                      <div style="text-align: left;">
                                        Applied by FedEx. <br>
                                      </div>
                                    </ng-template>
                                    <div placement="top" [openDelay]="100" [closeDelay]="200" [ngbTooltip]="dhlEss"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">{{selectedShipment?.peak_surcharge
                                    |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.emergency_situation_surcharge > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;width: max-content;">
                                      Emergency Situation Surcharge</p>
                                    <ng-template #dhlEss>
                                      <div style="text-align: left;">
                                        Applied by DHL. <br>
                                      </div>
                                    </ng-template>
                                    <div placement="top" [openDelay]="100" [closeDelay]="200" [ngbTooltip]="dhlEss"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.emergency_situation_surcharge |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.brexit_fee > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;width: max-content;">
                                      Brexit Adjustment Fee</p>
                                    <ng-template #residentalDeliveryCharge>
                                      <div style="text-align: left;">
                                        Applied by DHL. <br>
                                        Destination or Origin country U.K
                                      </div>
                                    </ng-template>
                                    <div placement="top" [openDelay]="100" [closeDelay]="200"
                                      [ngbTooltip]="residentalDeliveryCharge"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">{{selectedShipment?.brexit_fee |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.residential_delivery_charge > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;width: max-content;">
                                      Residential Delivery Charge</p>
                                    <ng-template #residentalDeliveryCharge>
                                      <div style="text-align: left;">
                                        Applied by FedEx. <br>
                                        Destination country Canada, and U.S. from all origin countries
                                      </div>

                                    </ng-template>
                                    <div placement="top" [openDelay]="100" [closeDelay]="200"
                                      [ngbTooltip]="residentalDeliveryCharge"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.residential_delivery_charge |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.oversize_package_fee > 0">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Oversize Package Fee</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.oversize_package_fee
                                    |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.export_declaration_fee > 0">
                                <td style="padding-left: 0px;">
                                  <div style="display: flex;">
                                    <p style="margin-bottom: 0;font-weight: bold;width: max-content;">
                                      Export Declaration Fee</p>
                                    <ng-template #declarationFee>
                                      <div style="text-align: left;">
                                        Applied by Customs in
                                        {{returnCountryName(selectedShipment?.b2b_user_address?.country)}}. <br>
                                      </div>
                                    </ng-template>
                                    <div placement="top" [openDelay]="100" [closeDelay]="200"
                                      [ngbTooltip]="declarationFee"
                                      style="margin-left:7px;width: 20px;height: 20px;background-color: black;border-radius: 5px;cursor: pointer;display: inline-grid;text-align: center;align-items: center;">
                                      <i style="font-size: 14px;color: white;" class="fas fa-info"></i>
                                    </div>
                                  </div>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.export_declaration_fee |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="+insuranceSelected">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Insurance Amount</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    <span>
                                      {{insuranceAmount | number:'1.2-2'}}
                                    </span>
                                    USD
                                  </p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.elevated_risk_fee > 0">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Elevated Risk Fee</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;" translate="no">
                                  <p style="margin-bottom: 0;">{{selectedShipment?.elevated_risk_fee |
                                    number:'1.2-2'}}
                                    USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.repacking_service_fee > 0">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Repacking Service Fee</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">
                                    {{selectedShipment?.repacking_service_fee
                                    |
                                    number:'1.2-2'}} USD</p>
                                </td>
                              </tr>
                              <tr *ngIf="selectedShipment?.storage_amount > 0">
                                <td style="padding-left: 0px;">
                                  <p style="margin-bottom: 0;font-weight: bold;">Storage Fee</p>
                                </td>
                                <td style="padding-right: 0px;text-align: right;">
                                  <p style="margin-bottom: 0;" translate="no">{{selectedShipment?.storage_amount
                                    |
                                    number:'1.2-2'}}
                                    USD</p>
                                </td>
                              </tr>
                              <tr>
                                <td style="padding-left: 0px;padding-bottom:0px;border-bottom: none;">
                                  <p style="margin-bottom: 0;font-weight: bold;font-size: 16px;">Total</p>
                                </td>
                                <td
                                  style="padding-right: 0px;padding-bottom:0px;text-align: right;border-bottom: none;">
                                  <p style="margin-bottom: 0;font-size: 16px;font-weight: bold;" translate="no"
                                    [ngStyle]="{'text-decoration': selectedShipment?.discount_amount > 0 ? 'line-through': 'none' }">
                                    <span *ngIf="+insuranceSelected == 0">
                                      {{selectedShipment?.total_shipment_amount | number:'1.2-2'}}
                                    </span><span *ngIf="+insuranceSelected == 1">
                                      {{(selectedShipment?.total_shipment_amount + insuranceAmount) |
                                      number:'1.2-2'}}
                                    </span> USD
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-step>
            <!-- Success -->
            <mat-step [stepControl]="paymentDone">
              <ng-template matStepLabel>Print Label</ng-template>
              <div class="shippn-b2b-create-shipment-stepper-step-container">
                <div class="row">
                  <div style="display: flex; flex-direction: column; gap: 5px; width: 100%">
                    <h4 style="padding-left: 15px">Thank You!</h4>
                    <p style="padding-left: 15px;">Your label has been created successfully.</p>
                  </div>

                  <div class="col-12 col-md-8">
                    <div class="shipment-details-wrapper">
                      <h5>Shipment Details</h5>
                      <div class="shipment-details-wrapper-titles">

                        <h5 class="title-sender">
                          Sender
                        </h5>
                        <div class="shipment-details-arrow-wrapper">
                          <i class="fas fa-long-arrow-alt-right"></i>
                        </div>
                        <h5 class="title-recipient">
                          Recipient
                        </h5>


                      </div>
                      <div class="shipment-details-sender-recipent-wrapper">

                        <div class="shipment-details-sender-information">
                          <div class="shipment-details-field">
                            <span for="" class="shipment-details-field-label">Sender Name</span>
                            <h6 class="shipment-details-field-text">
                              {{paymentCompletedShipment?.b2b_user_address?.name}} </h6>
                          </div>
                          <div class="shipment-details-field">
                            <span for="" class="shipment-details-field-label">Sender Email</span>
                            <h6 class="shipment-details-field-text">
                              {{paymentCompletedShipment?.b2b_user_address?.email}} </h6>
                          </div>
                          <div class="shipment-details-field">
                            <span for="" class="shipment-details-field-label">Sender Phone</span>
                            <h6 class="shipment-details-field-text">
                              {{paymentCompletedShipment?.b2b_user_address?.phone}} </h6>
                          </div>
                          <div class="shipment-details-field">
                            <span for="" class="shipment-details-field-label">From Address</span>
                            <p class="shipment-details-field-text shipment-details-field-address">
                              {{paymentCompletedShipment?.b2b_user_address?.street1}}
                              {{paymentCompletedShipment?.b2b_user_address?.street2}} <br>
                              {{paymentCompletedShipment?.b2b_user_address?.city}}
                              {{paymentCompletedShipment?.b2b_user_address?.state}}
                              {{paymentCompletedShipment?.b2b_user_address?.zip}}/
                              {{paymentCompletedShipment?.b2b_user_address?.country}}
                            </p>
                          </div>
                        </div>

                        <div class="shipment-details-divider"></div>

                        <div class="shipment-details-recipient-information">
                          <div class="shipment-details-field">
                            <span for="" class="shipment-details-field-label">Recipient Name</span>
                            <h6 class="shipment-details-field-text">
                              {{paymentCompletedShipment?.recipient_full_name}} </h6>
                          </div>
                          <div class="shipment-details-field">
                            <span for="" class="shipment-details-field-label">Recipient Email</span>
                            <h6 class="shipment-details-field-text">
                              {{paymentCompletedShipment?.recipient_address?.email}} </h6>
                          </div>
                          <div class="shipment-details-field">
                            <span for="" class="shipment-details-field-label">Recipient Phone</span>
                            <h6 class="shipment-details-field-text">
                              {{paymentCompletedShipment?.recipient_address?.phone}} </h6>
                          </div>
                          <div class="shipment-details-field">
                            <span for="" class="shipment-details-field-label">Recipient Address</span>
                            <p class="shipment-details-field-text shipment-details-field-address">
                              {{paymentCompletedShipment?.recipient_address?.street1}}
                              {{paymentCompletedShipment?.recipient_address?.street2}} <br>
                              {{paymentCompletedShipment?.recipient_address?.city}}
                              {{paymentCompletedShipment?.recipient_address?.state}}
                              {{paymentCompletedShipment?.recipient_address?.zip}}/
                              {{paymentCompletedShipment?.recipient_address?.country}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="shipment-details-content-wrapper">
                      <h5>Contents</h5>

                      <div class="shipment-details-contents-list">
                        <div class="shipment-details-content-item"
                          *ngFor="let b2bContentItem of paymentCompletedShipment?.content">

                          <div class="shipment-details-content-item-information">

                            <div class="shipment-details-content-item-information-field">
                              <span class="shipment-details-content-item-label">
                                Description of Item
                              </span>
                              <h6 class="shipment-details-content-item-text">{{b2bContentItem?.description}}
                              </h6>
                            </div>
                            <div class="shipment-details-content-item-information-field">
                              <span class="shipment-details-content-item-label">
                                Origin Country
                              </span>
                              <h6 class="shipment-details-content-item-text">
                                {{b2bContentItem?.origin_country}}</h6>
                            </div>

                            <div class="shipment-details-content-item-information-field">
                              <span class="shipment-details-content-item-label">
                                Quantity
                              </span>
                              <h6 class="shipment-details-content-item-text">{{b2bContentItem?.quantity}}</h6>
                            </div>

                            <div class="shipment-details-content-item-information-field">
                              <span class="shipment-details-content-item-label">
                                Total Weight
                              </span>
                              <h6 class="shipment-details-content-item-text">{{b2bContentItem?.weight}} lbs
                              </h6>
                            </div>

                            <div class="shipment-details-content-item-information-field">
                              <span class="shipment-details-content-item-label">
                                Total Value
                              </span>
                              <h6 class="shipment-details-content-item-text">
                                <span *ngIf="b2bContentItem?.currency == 'USD'">$</span>
                                <span *ngIf="b2bContentItem?.currency == 'EUR'">€</span>
                                {{b2bContentItem?.value}}
                              </h6>
                            </div>

                            <div class="shipment-details-content-item-information-field">
                              <span class="shipment-details-content-item-label">
                                Currency
                              </span>
                              <h6 class="shipment-details-content-item-text">{{b2bContentItem?.currency}}</h6>
                            </div>

                            <div class="shipment-details-content-item-information-field">
                              <span class="shipment-details-content-item-label">
                                HTS Code
                              </span>
                              <h6 class="shipment-details-content-item-text">
                                {{b2bContentItem?.hs_tariff_number}}</h6>
                            </div>
                            <div class="shipment-details-content-item-information-field">
                              <span class="shipment-details-content-item-label">
                                Product Identifier
                              </span>
                              <h6 class="shipment-details-content-item-text">
                                {{b2bContentItem?.productIdentifier}}</h6>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="shipment-details-payment-details-wrapper">
                      <h5>Payment Details</h5>
                      <div class="shipment-payment-details-wrapper">
                        <div class="shipment-payment-detail-fees-list">

                          <div class="shipment-payment-detail-fees-list-fee"
                            *ngIf="paymentCompletedShipment?.charge?.shipment?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Shipment Cost</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.shipment?.amount | number:'1.2-2'}}
                            </h6>
                          </div>


                          <div class="shipment-payment-detail-fees-list-fee"
                            *ngIf="paymentCompletedShipment?.charge?.additional_handling_surcharge?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Additional Handling
                              Surcharge</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.additional_handling_surcharge?.amount |
                              number:'1.2-2'}}</h6>
                          </div>

                          <div class="shipment-payment-detail-fees-list-fee"
                            *ngIf="paymentCompletedShipment?.charge?.brexit_fee?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Brexit Fee</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.brexit_fee?.amount | number:'1.2-2'}}</h6>
                          </div>

                          <div class="shipment-payment-detail-fees-list-fee"
                            *ngIf="paymentCompletedShipment?.charge?.elevated_risk_fee?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Elevated Risk Fee</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.elevated_risk_fee?.amount |
                              number:'1.2-2'}}
                            </h6>
                          </div>

                          <div class="shipment-payment-detail-fees-list-fee"
                            *ngIf="paymentCompletedShipment?.charge?.emergency_situation_surcharge?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Emergency Situation
                              Surcharge</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.emergency_situation_surcharge?.amount |
                              number:'1.2-2'}}</h6>
                          </div>

                          <div class="shipment-payment-detail-fees-list-fee"
                            *ngIf="paymentCompletedShipment?.charge?.export_declaration_fee?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Export Declaration Fee</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.export_declaration_fee?.amount |
                              number:'1.2-2'}}</h6>
                          </div>

                          <div class="shipment-payment-detail-fees-list-fee"
                            *ngIf="paymentCompletedShipment?.charge?.extended_area_fee?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Extended Area Fee</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.extended_area_fee?.amount |
                              number:'1.2-2'}}
                            </h6>
                          </div>

                          <div class="shipment-payment-detail-fees-list-fee"
                            *ngIf="paymentCompletedShipment?.charge?.insurance?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Insurance</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.insurance?.amount | number:'1.2-2'}}</h6>
                          </div>

                          <div class="shipment-payment-detail-fees-list-fee"
                            *ngIf="paymentCompletedShipment?.charge?.non_standart_pickup_fee?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Non Standart Pickup Fee</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.non_standart_pickup_fee?.amount |
                              number:'1.2-2'}}</h6>
                          </div>

                          <div class="shipment-payment-detail-fees-list-fee"
                            *ngIf="paymentCompletedShipment?.charge?.peak_surcharge?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Peak Surcharge</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.peak_surcharge?.amount | number:'1.2-2'}}
                            </h6>
                          </div>

                          <div class="shipment-payment-detail-fees-list-fee"
                            *ngIf="paymentCompletedShipment?.charge?.residential_delivery_charge?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Residential Delivery Charge</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.residential_delivery_charge?.amount |
                              number:'1.2-2'}}</h6>
                          </div>

                          <div class="shipment-payment-detail-fees-list-fee"
                            *ngIf="paymentCompletedShipment?.charge?.restricted_destination_fee?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Restricted Destination Fee</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.restricted_destination_fee?.amount |
                              number:'1.2-2'}}</h6>
                          </div>

                          <div class="shipment-payment-detail-fees-list-fee total-border-top"
                            *ngIf="paymentCompletedShipment?.charge?.paid?.amount > 0">
                            <label for="" class="shipment-payment-fee-label">Total Paid Amount</label>
                            <h6 translate="no">${{paymentCompletedShipment?.charge?.paid?.amount |
                              number:'1.2-2'}}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="shipment-details-success-actions-wrapper">

                      <button *ngIf="!paymentCompletedShipment.pick_up_arranged_date" mat-flat-button color="primary"
                        class="shippn-mat-btn"
                        [ngClass]="paymentCompletedShipment.pick_up_arranged_date ? 'shippn-mat-btn-alt': ''"
                        (click)="openArrangePickupDialog()">
                        <img *ngIf="!paymentCompletedShipment.pick_up_arranged_date" style="width: 25px;"
                          src="../../../../../assets/img/dashboard/delivery-truck-white.png" alt="">

                        <img *ngIf="paymentCompletedShipment.pick_up_arranged_date" style="width: 25px;"
                          src="../../../../../assets/img/dashboard/delivery-truck-orange.png" alt="">
                        <span *ngIf="!paymentCompletedShipment.pick_up_arranged_date"> Arrange Pickup</span>
                        <span *ngIf="paymentCompletedShipment.pick_up_arranged_date"> Pickup Details</span>
                      </button>

                      <button *ngIf="paymentCompletedShipment.pick_up_arranged_date" mat-flat-button color="primary"
                        class="shippn-mat-btn"
                        [ngClass]="paymentCompletedShipment.pick_up_arranged_date ? 'shippn-mat-btn-alt': ''"
                        (click)="openArrangePickupDetailDialog(paymentCompletedShipment)">
                        <img *ngIf="!paymentCompletedShipment.pick_up_arranged_date" style="width: 25px;"
                          src="../../../../../assets/img/dashboard/delivery-truck-white.png" alt="">

                        <img *ngIf="paymentCompletedShipment.pick_up_arranged_date" style="width: 25px;"
                          src="../../../../../assets/img/dashboard/delivery-truck-orange.png" alt="">
                        <span *ngIf="!paymentCompletedShipment.pick_up_arranged_date"> Arrange Pickup</span>
                        <span *ngIf="paymentCompletedShipment.pick_up_arranged_date"> Pickup Details</span>
                      </button>


                      <button mat-flat-button color="primary" class="shippn-mat-btn"
                        [ngClass]="paymentCompletedShipment.pick_up_arranged_date ? '': 'shippn-mat-btn-alt'"
                        (click)="printLabel(paymentCompletedShipment?.label_url)">
                        <img style="width: 25px;" src="../../../../../assets/img/dashboard/print_icon_white.svg" alt="">
                        Print Label</button>




                      <!-- <button mat-flat-button class="shippn-mat-btn shippn-mat-btn-alt"
                                [routerLink]="['/','b2b','shipments']">
                                <img src="../../../../../assets/img/dashboard/package_status_icon_orange.svg"
                                  alt="Package Status Icon" style="width: 25px;">
                                Shipments
                              </button> -->
                    </div>
                  </div>
                </div>

              </div>
            </mat-step>

          </mat-stepper>
          <div class="shippn-b2b-create-shipment-stepper-controls-wrapper"
            [ngClass]="(currentStep == 3 && !comingFromContactus)  ? 'justify-flex-start' : ''" *ngIf="currentStep < 4">
            <button mat-flat-button class="shippn-mat-btn shippn-mat-btn-alt" (click)="movePrevStep()"
              *ngIf="currentStep > 0 && currentStep < 4">
              Back: {{stepTitles[currentStep - 1]}}
            </button>
            <button mat-flat-button color="primary" class="shippn-mat-btn" (click)="moveNextStep()"
              [disabled]="!userCanMoveForward" *ngIf="currentStep < 3">Next: {{stepTitles[currentStep +
              1]}}</button>

            <button mat-flat-button color="primary" class="shippn-mat-btn"
              *ngIf="currentStep === 3 && comingFromContactus" [routerLink]="['/','b2b', 'sign-up']"
              (click)="goToB2BSignupWithShipment()">
              Create Account & Ship
            </button>

            <button mat-flat-button color="primary" class="shippn-mat-btn" *ngIf="currentStep === 4"
              [routerLink]="['/','b2b', 'shipments']">
              Shipments
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<!-- Paypal Verification Waiting Moda-->
<button style="width:0; height:0; display: none;" id="payPalVerificationModalButton" data-toggle="modal"
  data-target="#payPalVerificationModal"></button>
<!-- Modal -->
<div class="modal fade" id="payPalVerificationModal" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div style="max-width: 600px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="background: #222222;">
        <h5 style="color: white;padding-left: 15px;" class="modal-title" id="exampleModalLabel">
          PayPal Verification </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span style="color: white;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div style="text-align: left;max-height: 500px;overflow-y: auto;" class="col-md-12">
          <div style="color: #0f0f0f;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;"
            *ngIf="!payPalErrorMessage">

            <p style="text-align:center;">
              Waiting for PayPal verification.
            </p>
            <div
              style="background-image: url(../../assets/img/loading-black.gif);background-repeat: no-repeat;background-position: center;height: 35px;width: 100%;">
            </div>

          </div>
          <p *ngIf="payPalErrorMessage"
            style="color: #0f0f0f; font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
            {{payPalErrorMessage}}
          </p>

        </div>
      </div>
      <div class="modal-footer">
        <button style="width: 100px;font-size: 16px;font-weight: normal;height: 38px;" data-dismiss="modal"
          class="btn shippn-from-to-area-go-btn" id="paypalVerificationModalCloser">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="changeCreditCardModal" tabindex="-1" aria-labelledby="changeCreditCardModal"
  data-backdrop="static" data-keyboard="false">
  <div style="max-width: 600px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="background: #222222;">
        <h5 style="color: white;padding-left: 15px;" class="modal-title" id="exampleModalLabel">
          Change Credit Card </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span style="color: white;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div style="text-align: left;max-height: 500px;overflow-y: auto;" class="col-md-12">
          <div *ngFor="let creditCard of userCreditCardDataArray;"
            style="display: flex; flex-direction:row; gap:4px; margin-bottom: 10px;cursor:pointer;"
            (click)="newSelectedCard(creditCard)">
            <button (click)="newSelectedCard(creditCard)"
              [ngClass]="creditCard?.id == selectedCreditCard?.id ? 'active' : ''"
              class="radio-inlie payment-method-radio"></button>
            <div class="card-info">
              <div class="card-number-area" style="margin-top: -4px;">
                <span>***********<span
                    *ngIf="creditCard?.card_no_masked.length - 4 == 12">*</span></span><span translate="no">{{creditCard?.card_no_masked | slice:-4}}</span>
              </div>
              <div class="card-status-area" style="margin-top: -10px;">
                <span *ngIf="creditCard?.status == 3" style="font-size: 11px;">Verified</span>
                <span *ngIf="creditCard?.payment_method_id" style="font-size: 11px;"> with 3D
                  secure</span>
                <span
                  *ngIf="creditCard?.status == 4 || (creditCard?.status == 2 && creditCard?.verification_attempts >= 2) || (creditCard?.status == 1 && creditCard?.verification_attempts >= 2)"
                  style="font-size: 11px;">Failed
                  Verification</span>
                <span
                  *ngIf="creditCard?.status == 0 || creditCard?.status == 1 || (creditCard?.status == 2 && creditCard?.verification_attempts < 2)"
                  style="font-size: 11px;">Unverified</span>
              </div>
            </div>

          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button style="width: 100px;font-size: 16px;font-weight: normal;height: 38px;" data-dismiss="modal"
          class="btn shippn-from-to-area-go-btn">Select</button>
      </div>
    </div>
  </div>
</div>
<!-- Add Card Modal-->
<button id="hiddenAddCardModalOpener" data-toggle="modal" data-target="#addCardStartingModal"
  style="display: none!important; visibility: hidden!important; height:0px!important; width: 0px!important;"></button>
<!-- Additional trigger -->
<div class="modal fade" id="addCardStartingModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered add-credit-card-warning-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Credit Card Verification</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h5>
          Credit Card Verification Process
        </h5>

        <p>
          We will charge <strong>$0.50</strong> from your credit card. This charge will be refunded when you
          complete the verification process.
          <br />
          You will see this charge as <strong>"SHIPPN* XXXX-CODE"</strong> on your credit card statement.
        </p>

        <div>
          You'll need to:
          <ul>
            <li>Check your bank/credit card account in 1-2 business days for the verification code.</li>
            <li>Enter the verification code you saw on your credit card statement and click Verify.</li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
          style="background-color: #fe6c36;">PROCEED</button>
      </div>
    </div>
  </div>
</div>